export default __webpack_public_path__ + "static/media/pumpkin-l2.c944231d.webp";